<template>
  <div class="pricing-page">
    <Header />
    <main class="container-content-pricing">
      <div class="header">
        Выберите план, подходящий вам и вашей команде
      </div>

      <div class="switcher-wrapper">
        <div class="switcher-text">
          Вы можете оплачивать подписку ежемесячно или ежегодно и отменить её в любое время.
        </div>
        <plan-type-switcher @switched="onSwitched"></plan-type-switcher>
      </div>

      <div class="content-wrapper">
        <div class="cards-wrapper">
          <div class="card-wrapper">
            <pricing-card :name="'free'"></pricing-card>
          </div>
          <div class="card-wrapper">
            <pricing-card :name="'pro'" :monthly="monthly"></pricing-card>
          </div>
          <div class="card-wrapper">
            <pricing-card :name="'enterprise'"></pricing-card>
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="table-wrapper" :class="monthly ? 'monthly' : ''">
          <div class="table-title">Сравните тарифы и функции</div>
          <div class="table-plan-switcher-shadow" :class="{ sticky: sticky }"></div>
          <div class="table-plan-switcher" :class="{ sticky: sticky }">
            <div class="table-plan-switcher-items">
              <div @click="onPlanSelect($event, 'free')" class="table-plan-switcher-item">Бесплатно</div>
              <div @click="onPlanSelect($event, 'pro')" class="table-plan-switcher-item">Персональный</div>
              <div @click="onPlanSelect($event, 'enterprise')" class="table-plan-switcher-item">Корпоративный</div>
            </div>
            <div class="table-plan-switcher-marker">
              <div :style="markerStyle()"/>
            </div>
          </div>
          <div class="table-content" :class="{ 'fade-out': fadeOut }">
            <div v-for="(section, index) in sections" :key="index" class="table-section">
              <div class="table-section-header">
                <div class="table-section-title">
                  {{ section.title }}
                </div>
                <div class="table-section-values">
                  <div class="table-section-value">
                    Бесплатно
                  </div>
                  <div class="table-section-value">
                    Персональный
                  </div>
                  <div class="table-section-value">
                    Корпоративный
                  </div>
                </div>
              </div>
              <div v-for="(data, index) in section.data" :key="index" class="table-section-row">
                <div class="table-section-title">
                  {{ data.title }}
                </div>
                <div class="table-section-values">
                  <div v-for="(data, index) in data.data" :key="index" class="table-section-value" :style="style(data.title)">
                    <inline-svg v-if="data.data === 'included'" src="/images/v4/svg/icon-checkmark.svg" />
                    <div v-else-if="data.data === 'notIncluded'"></div>
                    <template v-else-if="Array.isArray(data.data)">
                      <span v-for="(data, index) in data.data" :key="index" :class="`type-${ data.title }`">{{ data.data }}</span>
                    </template>
                    <template v-else>
                      {{ data.data }}
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div class="buttons-section">
              <a :style="style('free')" :href="signupUrl" class="ui-button-primary-outline mod_size-s">
                Регистрация
              </a>
              <a :style="style('pro')" :href="signupUrlPro" class="ui-button-primary mod_size-xs">
                Купить
              </a>
              <a :style="style('enterprise')" href="mailto:info@coverse.team" class="ui-button-primary-outline mod_size-s">
                Запросить
              </a>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="faq-wrapper">
          <div class="faq-header">
            <div class="faq-title">
              Часто задаваемые вопросы
            </div>
            <div class="faq-text">
              Не можете найти ответы на интересующие вас вопросы? Напишите на <a href="mailto:info@coverse.team">info@coverse.team</a>.
            </div>
          </div>
          <div class="faq-questions">
            <div class="faq-ask">
              Могу ли я выбрать оплату ежемесячно?
            </div>
            <div class="faq-answer">
              Вы можете выбрать ежемесячную или ежегодную оплату, кликнув по нужному варианту над планами. При ежегодной подписке вы сэкономите 20%.
            </div>
            <div class="faq-ask">
              Могу ли я изменить свой тариф в&nbsp;любое&nbsp;время?
            </div>
            <div class="faq-answer">
              Мы понимаем, что команды могут расти или сокращаться, поэтому вы можете менять свой план в любое время.
            </div>
            <div class="faq-ask">
              Как я могу оплатить тариф?
            </div>
            <div class="faq-answer">
              Вы можете оплатить подписку с помощью платежной карты (МИР, Visa или Mastercard) или банковского перевода. Если у вас возникли проблемы с оплатой, <a href="mailto:info@coverse.team">свяжитесь</a> с нами.
            </div>
            <div class="faq-ask">
              Какие правила отмены подписки?
            </div>
            <div class="faq-answer">
              Вы можете отменить подписку в любое время. Хотите временно приостановить подписку, <a href="mailto:info@coverse.team">свяжитесь</a> с нами.
            </div>
            <div class="faq-ask">
              Предоставляете ли вы скидку?
            </div>
            <div class="faq-answer">
              Мы будем рады предоставить скидку на годовые планы для некоммерческих и образовательных организаций, имеющих право на скидку.
            </div>
          </div>
        </div>
      </div>
    </main>
    <Footer />
  </div>
</template>

<script>
import PlanTypeSwitcher from "./partials/PlanTypeSwitcher";
import PricingCard from "./partials/PricingCard";
import Header from "@/components/partials/Header";
import Footer from "@/components/partials/Footer";

export default {
  name: 'Pricing',
  components: {
    Header,
    Footer,
    PlanTypeSwitcher,
    PricingCard,
  },
  data() {
    return {
      monthly: false,
      current: 'free',
      fadeOut: false,
      markerLeft: 0,
      markerWidth: 34,
      sticky: false,
      style: (plan) => {
        if (this.current === plan) {
          return {
            display: 'block',
          }
        }

        return {};
      },
      markerStyle: () => {
        return {
          left: `${ this.markerLeft }px`,
          width: `${ this.markerWidth }px`,
        };
      },
      sections: [
        {
          title: 'лимиты',
          data: [
            {
              title: 'Цена',
              data: [
                {
                  title: 'free',
                  data: [
                    {
                      title: 'monthly',
                      data: '0 руб.',
                    },
                    {
                      title: 'annually',
                      data: '0 руб.',
                    },
                  ],
                },
                {
                  title: 'pro',
                  data: [
                    {
                      title: 'monthly',
                      data: '590 руб.',
                    },
                    {
                      title: 'annually',
                      data: '5700 руб.',
                    },
                  ],
                },
                {
                  title: 'enterprise',
                  data: 'По запросу',
                },
              ],
            },
            {
              title: 'Количество рабочих пространств',
              data: [
                {
                  title: 'free',
                  data: '1',
                },
                {
                  title: 'pro',
                  data: 'Безлимит',
                },
                {
                  title: 'enterprise',
                  data: 'Безлимит',
                }
              ],
            },
            {
              title: 'Количество участников',
              data: [
                {
                  title: 'free',
                  data: 'Безлимит',
                },
                {
                  title: 'pro',
                  data: 'Безлимит',
                },
                {
                  title: 'enterprise',
                  data: 'Безлимит',
                }
              ],
            },
            {
              title: 'Количество файлов',
              data: [
                {
                  title: 'free',
                  data: 'Безлимит',
                },
                {
                  title: 'pro',
                  data: 'Безлимит',
                },
                {
                  title: 'enterprise',
                  data: 'Безлимит',
                }
              ],
            },
            {
              title: 'Доступное дисковое пространство',
              data: [
                {
                  title: 'free',
                  data: '100 Мб',
                },
                {
                  title: 'pro',
                  data: 'Безлимит',
                },
                {
                  title: 'enterprise',
                  data: 'Безлимит',
                }
              ],
            },
          ],
        },
        {
          title: 'функционал',
          data: [
            {
              title: 'Искусственный интеллект',
              data: [
                {
                  title: 'free',
                  data: '10 ответов',
                },
                {
                  title: 'pro',
                  data: 'included',
                },
                {
                  title: 'enterprise',
                  data: 'included',
                }
              ],
            },
            {
              title: 'Уведомления',
              data: [
                {
                  title: 'free',
                  data: 'included',
                },
                {
                  title: 'pro',
                  data: 'included',
                },
                {
                  title: 'enterprise',
                  data: 'included',
                }
              ],
            },
            {
              title: 'Видео чат',
              data: [
                {
                  title: 'free',
                  data: 'included',
                },
                {
                  title: 'pro',
                  data: 'included',
                },
                {
                  title: 'enterprise',
                  data: 'included',
                }
              ],
            },
            {
              title: 'Управление задачами',
              data: [
                {
                  title: 'free',
                  data: 'included',
                },
                {
                  title: 'pro',
                  data: 'included',
                },
                {
                  title: 'enterprise',
                  data: 'included',
                }
              ],
            },
          ],
        },
        {
          title: 'совместное использование',
          data: [
            {
              title: 'Совместная работа в реальном времени',
              data: [
                {
                  title: 'free',
                  data: 'included',
                },
                {
                  title: 'pro',
                  data: 'included',
                },
                {
                  title: 'enterprise',
                  data: 'included',
                }
              ],
            },
            {
              title: 'Приватный доступ к файлам',
              data: [
                {
                  title: 'free',
                  data: 'included',
                },
                {
                  title: 'pro',
                  data: 'included',
                },
                {
                  title: 'enterprise',
                  data: 'included',
                }
              ],
            },
            {
              title: 'Публичный доступ к файлам',
              data: [
                {
                  title: 'free',
                  data: 'included',
                },
                {
                  title: 'pro',
                  data: 'included',
                },
                {
                  title: 'enterprise',
                  data: 'included',
                }
              ],
            },
            {
              title: 'Защита файлов от редактирования',
              data: [
                {
                  title: 'free',
                  data: 'notIncluded',
                },
                {
                  title: 'pro',
                  data: 'included',
                },
                {
                  title: 'enterprise',
                  data: 'included',
                }
              ],
            },
          ],
        },
        {
          title: 'административный функционал',
          data: [
            {
              title: 'Ограничение на просмотр файлов',
              data: [
                {
                  title: 'free',
                  data: 'notIncluded',
                },
                {
                  title: 'pro',
                  data: 'included',
                },
                {
                  title: 'enterprise',
                  data: 'included',
                }
              ],
            },
            {
              title: 'Управление доступами',
              data: [
                {
                  title: 'free',
                  data: 'notIncluded',
                },
                {
                  title: 'pro',
                  data: 'included',
                },
                {
                  title: 'enterprise',
                  data: 'included',
                }
              ],
            },
            {
              title: 'Управление правами публикации файлов',
              data: [
                {
                  title: 'free',
                  data: 'notIncluded',
                },
                {
                  title: 'pro',
                  data: 'included',
                },
                {
                  title: 'enterprise',
                  data: 'included',
                }
              ],
            },
            {
              title: 'Расширенные админ роли',
              data: [
                {
                  title: 'free',
                  data: 'notIncluded',
                },
                {
                  title: 'pro',
                  data: 'notIncluded',
                },
                {
                  title: 'enterprise',
                  data: 'included',
                }
              ],
            },
            {
              title: 'Многофакторная аутентификация',
              data: [
                {
                  title: 'free',
                  data: 'notIncluded',
                },
                {
                  title: 'pro',
                  data: 'notIncluded',
                },
                {
                  title: 'enterprise',
                  data: 'included',
                }
              ],
            },
          ],
        },
        {
          title: 'безопасность',
          data: [
            {
              title: 'SSL',
              data: [
                {
                  title: 'free',
                  data: 'included',
                },
                {
                  title: 'pro',
                  data: 'included',
                },
                {
                  title: 'enterprise',
                  data: 'included',
                }
              ],
            },
            {
              title: 'SSO авторизация',
              data: [
                {
                  title: 'free',
                  data: 'notIncluded',
                },
                {
                  title: 'pro',
                  data: 'notIncluded',
                },
                {
                  title: 'enterprise',
                  data: 'included',
                }
              ],
            },
            {
              title: 'Повышенная безопасность бизнеса',
              data: [
                {
                  title: 'free',
                  data: 'notIncluded',
                },
                {
                  title: 'pro',
                  data: 'notIncluded',
                },
                {
                  title: 'enterprise',
                  data: 'included',
                }
              ],
            },
            {
              title: 'Ведение журнала аудита пользователей',
              data: [
                {
                  title: 'free',
                  data: 'notIncluded',
                },
                {
                  title: 'pro',
                  data: 'notIncluded',
                },
                {
                  title: 'enterprise',
                  data: 'included',
                }
              ],
            },
          ],
        },
        {
          title: 'поддержка',
          data: [
            {
              title: 'Онлайн центр поддержки',
              data: [
                {
                  title: 'free',
                  data: 'included',
                },
                {
                  title: 'pro',
                  data: 'included',
                },
                {
                  title: 'enterprise',
                  data: 'included',
                }
              ],
            },
            {
              title: 'Клиентская поддержка',
              data: [
                {
                  title: 'free',
                  data: 'notIncluded',
                },
                {
                  title: 'pro',
                  data: 'included',
                },
                {
                  title: 'enterprise',
                  data: 'included',
                }
              ],
            },
            {
              title: 'Приоритетная поддержка',
              data: [
                {
                  title: 'free',
                  data: 'notIncluded',
                },
                {
                  title: 'pro',
                  data: 'notIncluded',
                },
                {
                  title: 'enterprise',
                  data: 'included',
                }
              ],
            },
            {
              title: 'Помощь в адаптации в продукте',
              data: [
                {
                  title: 'free',
                  data: 'notIncluded',
                },
                {
                  title: 'pro',
                  data: 'notIncluded',
                },
                {
                  title: 'enterprise',
                  data: 'included',
                }
              ],
            },
            {
              title: 'Выделенный менеджер по работе с клиентом',
              data: [
                {
                  title: 'free',
                  data: 'notIncluded',
                },
                {
                  title: 'pro',
                  data: 'notIncluded',
                },
                {
                  title: 'enterprise',
                  data: 'included',
                }
              ],
            },
          ],
        }
      ],
    }
  },
  methods: {
    onSwitched(type) {
      this.monthly = type;
    },
    onPlanSelect(event, plan) {
      this.fadeOut = true;

      this.markerLeft = event.target.offsetLeft - 20;
      this.markerWidth = event.target.clientWidth;

      setTimeout(() => {
        this.current = plan;
        this.fadeOut = false;
      }, 300);
    },
    setSticky() {
      const shadow = document.getElementsByClassName('table-plan-switcher-shadow')[0];
      const headerH = 110;
      const planIndex = this.current === 'free' ? 0 : (this.current === 'pro' ? 1 : 2);
      const planItem = document.getElementsByClassName('table-plan-switcher-item')[planIndex];

      this.markerLeft = planItem?.offsetLeft - 20;
      this.markerWidth = planItem?.clientWidth;

      if (!shadow) return;

      this.sticky = window.scrollY + headerH > shadow.offsetTop;
    },
  },
  mounted() {
    this.markerWidth = document.getElementsByClassName('table-plan-switcher-item')[0]?.clientWidth ?? 34;

    window.addEventListener('scroll', this.setSticky, true);
    window.addEventListener('resize', this.setSticky, true);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.setSticky, true);
    window.removeEventListener('resize', this.setSticky, true);
  },
}
</script>

<style scoped lang="scss">
@import "../../../node_modules/bootstrap/scss/functions";
@import "../../../node_modules/bootstrap/scss/variables";
@import "../../../node_modules/bootstrap/scss/mixins";
@import "../../../node_modules/bootstrap/scss/utilities";
@import "../../styles/breakpoints";
@import "../../styles/fonts";
@import "@/styles/button-primary-outline";
@import "@/styles/button-primary";

.pricing-page {
  overflow: hidden;
}

.container-content-pricing {
  max-width: 1240px;
  margin: 0 auto;
  padding: 0 30px;
}

.header {
  font-size: 48px;
  line-height: 60px;
  margin-top: 111px;
  font-weight: 700;
  margin-bottom: 37px;
  color: #333334;
  max-width: 750px;
}

.switcher-wrapper {
  margin-bottom: 66px;

  .switcher-text {
    font-size: 20px;
    line-height: 28px;
    margin-bottom: 18px;
  }
}

.content-wrapper {
  .cards-wrapper {
    display: flex;
    justify-content: space-between;
    margin-bottom: 64px;
  }

  .table-wrapper {
    margin-bottom: 49px;
  }
}

.faq-wrapper {
  color: #333334;
  display: flex;
  align-items: baseline;
  padding-bottom: 30px;

  a {
    color: #597af4;
    transition: color 0.3s ease;

    &:hover {
      color: darken(#597af4, 10%);
    }
  }
}

.faq-header {
  margin-right: 62px;

  .faq-title {
    font-size: 32px;
    font-weight: 700;
    line-height: 44px;
    margin-bottom: 14px;
  }

  .faq-text {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    width: 330px;
  }
}

.faq-questions {
  width: 440px;
}

.faq-sub-header {
  margin-bottom: 44px;

  a {
    color: #c5c6ca;
  }
}

.faq-ask {
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  margin-bottom: 9px;
}

.faq-answer {
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 32px;
}

.table-wrapper {
  width: 100%;
  border-radius: 4px;
  padding: 38px 0 40px;

  .table-plan-switcher-shadow {
    display: none;
  }

  .table-plan-switcher {
    display: none;
  }

  .type-monthly {
    display: none;
  }

  &.monthly {
    .type-monthly {
      display: block;
    }

    .type-annually {
      display: none;
    }
  }

  .table-title {
    color: #333334;
    line-height: 30px;
    font-weight: 700;
    margin-bottom: 22px;
    font-size: 32px;
  }

  .table-content {
    transition: opacity 0.3s ease;
    &.fade-out {
      opacity: 0;
    }

    .table-section {
      margin-bottom: 14px;
    }

    .table-section-header {
      display: flex;
      justify-content: space-between;
      align-items: baseline;
      padding: 10px 0 3px;

      .table-section-title {
        text-transform: uppercase;
        color: #9b9b9b;
        font-size: 12px;
        font-weight: 600;
        letter-spacing: 1px;
        line-height: 17px;
      }

      .table-section-values {
        display: flex;

        .table-section-value {
          font-weight: 600;
          color: #333334;
          font-size: 16px;
          line-height: 22px;
          width: 144px;
          text-align: center;
          margin-right: 35px;

          &:nth-child(3) {
            margin-right: 0;
          }
        }
      }
    }

    .table-section-row {
      background: #f1f1f1;
      border-radius: 4px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 8px 0 8px 19px;
      margin-bottom: 10px;

      .table-section-title {
        font-weight: 600;
        color: #333334;
        font-size: 14px;
        line-height: 24px;
      }

      .table-section-values {
        display: flex;

        .table-section-value {
          display: block;
          width: 144px;
          color: #333334;
          font-size: 14px;
          line-height: 24px;
          text-align: center;
          margin-right: 35px;

          &:nth-child(3) {
            margin-right: 0;
          }

          svg {
            width: 20px;
            height: 20px;
            fill: #58D682;
            vertical-align: text-bottom;
          }
        }
      }
    }

    .buttons-section {
      display: flex;
      justify-content: flex-end;
      margin-top: 20px;

      a {
        width: 124px;
        margin-right: 56px;
        display: block;

        &:nth-child(3) {
          margin-right: 7px;
        }
      }
    }
  }
}

@include media-breakpoint-down($size-desktop) {

}

@include media-breakpoint-down($size-tablet) {
  .container-content-pricing {
    padding: 0 30px;
  }

  .header {
    margin-bottom: 13px;
    font-size: 38px;
    line-height: 48px;
    margin-top: 111px;
    width: 530px;
  }

  .switcher-wrapper {
    margin-bottom: 45px;

    .switcher-text {
      font-size: 16px;
      line-height: 28px;
      margin-bottom: 38px;
    }
  }

  .content-wrapper {
    margin-bottom: -14px;

    .cards-wrapper {
      margin-bottom: 5px;
    }

    .table-wrapper {
      margin-bottom: 39px;
    }

    .faq-wrapper {
      margin-top: 0;
      display: block;
      padding: 0 0 42px;
    }
  }

  .table-wrapper {
    padding: 38px 0 40px;

    .table-title {
      font-size: 24px;
      line-height: 30px;
      margin-bottom: 18px;
    }

    .table-content {
      .table-section-header {
        .table-section-values {
          .table-section-value {
            width: 127px;
            margin-right: 15px;

            &:nth-child(3) {
              margin-right: 15px;
            }
          }
        }
      }

      .table-section-row {
        .table-section-values {
          .table-section-value {
            width: 127px;
            margin-right: 15px;

            &:nth-child(3) {
              margin-right: 15px;
            }
          }
        }
      }

      .buttons-section {
        a {
          width: 124px;
          margin-right: 19px;

          &:nth-child(3) {
            margin-right: 16px;
          }
        }
      }
    }
  }

  .faq-header {
    margin-bottom: 48px;

    .faq-title {
      font-size: 24px;
      line-height: 33px;
      margin-bottom: 16px;
    }

    .faq-text {
      width: auto;
    }
  }
}

@include media-breakpoint-down($size-mobile) {
  .outro-container {
    padding-top: 0;
  }

  .container-content-pricing {
    padding: 0;
  }

  .header {
    font-size: 22px;
    line-height: 30px;
    margin-top: 137px;
    margin-bottom: 4px;
    text-align: left;
    padding: 0 20px;
    width: auto;
  }

  .switcher-wrapper {
    margin-bottom: 4px;
    padding: 0 20px;

    .switcher-text {
      font-size: 12px;
      line-height: 18px;
      margin-top: 20px;
      margin-bottom: 36px;
    }
  }

  .content-wrapper {
    margin-bottom: 73px;
    margin-top: 35px;

    .cards-wrapper {
      display: block;
      margin-bottom: 6px;
      padding: 0 20px;
    }

    .card-wrapper {
      margin-right: 0;
      float: none;

      &:nth-child(1) {
        margin-top: 0;
      }

      margin-left: 0;
      margin-top: 18px;
    }

    .table-wrapper {
      margin-bottom: 19px;
    }

    .faq-wrapper {
      padding: 0 20px;
    }
  }

  .table-wrapper {
    border-radius: 0;
    padding: 21px 20px 44px;

    .table-title {
      font-size: 20px;
      line-height: 30px;
      margin-bottom: 9px;
    }

    .table-content {
      margin-top: 8px;

      .table-section {
        margin-bottom: 18px;
      }

      .table-section-header {
        padding: 10px 0 5px;

        .table-section-values {
          display: none;

          .table-section-value {
            &:nth-child(3) {
              margin-right: 0;
            }
          }
        }
      }

      .table-section-row {
        padding: 8px 10px 8px 10px;

        .table-section-title {
          font-size: 12px;
          width: 100%;
          overflow: visible;
          padding-right: 10px;
        }

        .table-section-values {
          white-space: nowrap;
          max-width: 70px;

          .table-section-value {
            display: none;
            font-size: 12px;
            text-align: right;
            margin-right: 0;
            width: auto;

            &:nth-child(3) {
              margin-right: 0;
            }

            svg {
              margin-top: -2px;
              vertical-align: middle;
            }
          }
        }
      }

      .buttons-section {
        margin-top: 20px;

        a {
          display: none;
          margin-right: 0;

          &:nth-child(3) {
            margin-right: 0;
          }
        }
      }
    }

    .table-plan-switcher-shadow {
      display: block;

      &.sticky {
        height: 44px;
      }
    }

    .table-plan-switcher {
      display: inline-block;
      width: 100%;

      &.sticky {
        position: fixed;
        top: 110px;
        background: #f3f5f5;
        padding: 0 20px;
        right: 0;
        left: 0;
        z-index: 999;
      }

      .table-plan-switcher-items {
        display: flex;
        width: 100%;
        font-weight: 600;
        font-size: 12px;
        line-height: 22px;
        color: #333334;
        margin: 10px 0;

        .table-plan-switcher-item {
          margin: 0 auto;
          text-align: center;
          cursor: pointer;

          &:nth-child(1) {
            margin-left: 0;
            text-align: left;
          }

          &:nth-child(3) {
            margin-right: 0;
            text-align: right;
          }
        }
      }

      .table-plan-switcher-marker {
        background-color: #dadadb;
        width: 100%;
        height: 2px;
        position: relative;

        div {
          position: absolute;
          left: 0;
          top: 0;
          height: 2px;
          background-color: #ff5605;
          transition: left 0.3s ease, width 0.3s ease;
        }
      }
    }
  }

  .faq-header {
    margin-bottom: 6px;
    margin-right: 0;

    .faq-title {
      font-size: 20px;
      line-height: 27px;
      margin-bottom: 9px;
    }

    .faq-text {
      font-size: 12px;
      line-height: 20px;
      margin-bottom: 29px;
    }
  }

  .faq-questions {
    width: auto;
  }

  .faq-ask {
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 6px;
  }

  .faq-answer {
    font-size: 12px;
    line-height: 20px;
    margin-bottom: 25px;
  }

  .faq-sub-header {
    margin-bottom: 35px;
  }
}
</style>
